import React, { useContext } from 'react';
import { ThemeContext } from "../../../../context/theme/ThemeContext";
import { settingContext } from '../../../../context/Setting/Setting';
import { CalendarMonth, NotificationsNone } from '@mui/icons-material';
import moment from 'moment';
import { ModalLayout } from '../../../../components';
import { EventInfo } from '../..';
import { AuthContext } from '../../../../context/auth/ApiContext';
import { Link, useLocation, useHistory } from "react-router-dom";

function Index(props) {
    const { user, event, inbox } = props;
    const { theme, changeTheme } = useContext(ThemeContext);
    const { logOut } = React.useContext(AuthContext);
    const { page } = React.useContext(settingContext);
    const [isModal, setModal] = React.useState(false);
    const [meeting, setMeeting] = React.useState({});

    const openMeetingLink = (meeting) => {
        setMeeting(meeting);
        setModal(true);
    };

    const showNav = () => {
        var element = document.getElementById("sidebar");
        let classData = element.getAttribute("class");
        if (classData.includes("active")) {
            element.classList.remove("active");
        }
        else {
            element.classList.add("active");
        }
    }
    return (
        <nav className="navbar col-lg-12 col-12 px-0 py-0 py-lg-4 d-flex flex-row">
            <div className='header-overlay'></div>
            <div className="navbar-menu-wrapper d-flex align-items-center justify-content-end">
                {/* <button className="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
                    <span className="mdi mdi-menu" />
                </button> */}
                <div className="navbar-brand-wrapper">
                    <a className="navbar-brand brand-logo bg-gray-900 rounded" href="/"><img width={user?.image ? "50" : "60"} src={process.env.REACT_APP_LOCAL_FILE_PATH +
                        "setting/small/" +
                        page?.setting?.logo} alt="logo" /></a>
                    <a className="navbar-brand brand-logo-mini bg-gray-900 rounded" href="/"><img src={process.env.REACT_APP_LOCAL_FILE_PATH +
                        "setting/small/" +
                        page?.setting?.logo} alt="logo" /></a>
                </div>
                <h3 className="font-bold mb-0 d-none d-md-block mt-1 text-white">{page?.setting?.app_name}</h3>
                <ul className="navbar-nav navbar-nav-right">
                    <li className="nav-item">
                        <h4 className="mb-0 font-bold d-none d-xl-block text-white">{moment().format("LL")}</h4>
                    </li>
                    <li className="nav-item dropdown me-1">
                        <a className="nav-link count-indicator dropdown-toggle d-flex justify-content-center align-items-center" id="messageDropdown" href="#" data-bs-toggle="dropdown">
                            <i className="mdi mdi-calendar mx-0" />
                            <span className="count bg-info">{event?.reminder?.length + event?.event?.length}</span>
                        </a>
                        <div className="dropdown-menu dropdown-menu-right navbar-dropdown preview-list" aria-labelledby="messageDropdown">
                            <div className='d-flex flex-column'>
                                <p className="mb-0 font-weight-normal float-left dropdown-header">Reminder</p>
                                {event?.reminder?.map((item, index) => (
                                    <a onClick={() => openMeetingLink(item?.reminder)} className="dropdown-item preview-item">
                                        <div className="preview-thumbnail">
                                            <CalendarMonth />
                                        </div>
                                        <div className="preview-item-content flex-grow">
                                            <h6 className="preview-subject ellipsis font-weight-normal">{item?.course?.title}
                                            </h6>
                                            <p className="font-weight-light small-text text-muted mb-0">
                                                {moment(item.start_date).format("LL")}
                                            </p>
                                        </div>
                                    </a>
                                ))}
                                <br />
                                <p className="mb-0 font-weight-normal float-left dropdown-header">Events</p>
                                {event?.event?.map((item, index) => (
                                    <a onClick={() => openMeetingLink(item?.meeting)} className="dropdown-item preview-item">
                                        <div className="preview-thumbnail">
                                            <NotificationsNone />
                                        </div>
                                        <div className="preview-item-content flex-grow">
                                            <h6 className="preview-subject ellipsis font-weight-normal">{item.meeting?.title}
                                            </h6>
                                            <p className="font-weight-light small-text text-muted mb-0">
                                                {moment(item.start_date).format("LL")}
                                            </p>
                                        </div>
                                    </a>
                                ))}
                            </div>


                        </div>
                    </li>
                    <li className="nav-item dropdown me-2">
                        <a className="nav-link count-indicator dropdown-toggle d-flex align-items-center justify-content-center" id="notificationDropdown" href="#" data-bs-toggle="dropdown">
                            <i className="mdi mdi-email-open mx-0" />
                            <span className="count bg-danger">{inbox?.count_unread}</span>
                        </a>
                        <div className="dropdown-menu dropdown-menu-right navbar-dropdown preview-list" aria-labelledby="notificationDropdown">
                            <p className="mb-0 font-weight-normal float-left dropdown-header">Messages</p>
                            {inbox?.inbox?.data?.map((item, index) => {
                                if (index < 5) {
                                    return (
                                        <a className="dropdown-item preview-item">
                                            <div className="preview-thumbnail">
                                                {item?.send_by?.image &&
                                                    <img src={process.env.REACT_APP_LOCAL_FILE_PATH + "profile/medium/" + item?.send_by?.image} />}
                                                {!item?.send_by?.image &&
                                                    <div className="preview-icon bg-success">
                                                        <i className="mdi mdi-information mx-0" />
                                                    </div>}
                                            </div>
                                            <div className="preview-item-content">
                                                <h6 className="preview-subject font-weight-normal">{item?.send_by?.first_name} {item?.send_by?.last_name}</h6>
                                                <p className="font-weight-light small-text mb-0 text-muted">
                                                    {moment(item?.created_at).fromNow()}
                                                </p>
                                            </div>
                                        </a>
                                    )
                                }

                            })}
                        </div>
                    </li>
                </ul>


                <button onClick={showNav} className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
                    <span className="mdi mdi-menu" />
                </button>
            </div>
            <div className={theme === "light" ? "l_s_b navbar-menu-wrapper navbar-search-wrapper d-none d-lg-flex align-items-center d_t" : "d_s_b navbar-menu-wrapper navbar-search-wrapper d-none d-lg-flex align-items-center l_t"}>
                <ul className={"navbar-nav mr-lg-2"}>
                    <li className="nav-item nav-search d-none d-lg-block">
                        {/* <div className="input-group">
            <input type="text" className="form-control" placeholder="Search Here..." aria-label="search" aria-describedby="search" />
          </div> */}
                    </li>
                </ul>
                <ul className="navbar-nav navbar-nav-right">
                    <li className="nav-item nav-profile dropdown">
                        <a className="d-flex flex-row nav-link " href="#" data-bs-toggle="dropdown" id="profileDropdown">
                            <img width={user?.image ? "40" : "60"} src={user?.image ? process.env.REACT_APP_LOCAL_FILE_PATH + "profile/medium/" + user.image : user?.gender === "male" ? '/static/media/male.png' : '/static/media/female.png'} alt="profile" />
                            <span className={theme === "light" ? "d_t nav-profile-name" : "l_t nav-profile-name"}>{user?.first_name} {user?.last_name}</span>
                            <i className="mdi mdi-menu-down"></i>
                        </a>
                        <div className={theme === "light" ? "ll_b dropdown-menu dropdown-menu-right navbar-dropdown" : "d_s_b dropdown-menu dropdown-menu-right navbar-dropdown"} aria-labelledby="profileDropdown">
                            <Link to="/student/profile">
                                <a className="dropdown-item">
                                    <i className="mdi mdi-settings text-primary" />
                                    Profile Information
                                </a>
                            </Link>
                            <button onClick={logOut} className="dropdown-item">
                                <i className="mdi mdi-logout text-primary" />
                                Logout
                            </button>
                        </div>
                    </li>
                    <li className="nav-item">
                        <a href="#" className={theme === "light" ? "nav-link icon-link" : "l_t nav-link icon-link"}>
                            <i className="mdi mdi-plus-circle-outline" />
                        </a>
                    </li>
                    <li className="nav-item">
                        <a href="#" className={theme === "light" ? "nav-link icon-link" : "l_t nav-link icon-link"}>
                            <i className="mdi mdi-web" />
                        </a>
                    </li>
                    <li className="nav-item">
                        <a href="#" className={theme === "light" ? "nav-link icon-link" : "l_t nav-link icon-link"}>
                            <i className="mdi mdi-clock-outline" />
                        </a>
                    </li>
                </ul>
            </div>
            <ModalLayout
                modal={isModal}
                backgroundColor={theme === "light" ? "background.paper" : "#212121"}
                content={
                    <>
                        <EventInfo meeting={meeting} setModal={setModal} />
                    </>
                }
            />
        </nav>
    );
}

export default Index;